import EntityCrudPage from '../../shared/EntityCrudPage';
import { systemOwnerConfig } from '../../config/entityConfigs';

const SystemOwnersPage = () => <EntityCrudPage config={systemOwnerConfig} />;

export default SystemOwnersPage;
